// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__E2hOo","requiredAsterisk":"Info_requiredAsterisk__v_4W7"};